import {
	forwardRef,
	useEffect,
	type FunctionComponent,
} from "react";

import { createPortal, } from "react-dom";
import { TokenPill, } from "@components";
import { Panel, } from "@bracket/react-panel";
import type { TokenDefinition, } from "@bracket/addressbook";



export declare type AssetDDPanelProps = {
	active: TokenDefinition;
	tokens: TokenDefinition[];
	rect: DOMRect;
	DOMSelector?: string;
	exclude?: string[];
	onSelect: ( asset: TokenDefinition, ) => void;
};



export const AssetDDPanel: FunctionComponent<AssetDDPanelProps> = forwardRef(({
	active,
	tokens,
	rect,
	DOMSelector = "#connManUIRoot",
	exclude = null,
	onSelect = ( ) => { },
}, ref, ) => {


	const classes = () => [ "asset-dd-panel", ].join(" ");
	const target = document.querySelector(DOMSelector);

	const style = () => {
		return {
			position: "absolute" as const,
			pointerEvents: "all" as const,
			left: `${rect.left}px`,
			top: `${rect.top + rect.height}px`,
			minWidth: `${rect.width}px`,
		}
	}

	const renderableTokens = exclude
		? tokens.filter(token => !(exclude.includes(token.symbol) || exclude.includes(token.label)))
		: tokens.concat();

	if(target) {
		return createPortal(
			<Panel className={classes()} style={style()} ref={ref}>
			{
				renderableTokens.map( ( definition, idx ) => 
					definition !== active && definition.symbol !== active.symbol
					? (
						<TokenPill
							key={definition.symbol}
							token={definition}
							onClick={onSelect}
							container
							disabled={definition.inactive} />
					)
					: null
				)
			}
			</Panel>,
			target
		);
	}

	throw new Error(`AssetDepost::AssetDDPanel failed finding DOM target "${DOMSelector}"`)

});
